import React from 'react';
import { motion } from 'framer-motion';
export function IntroducingSection() {
  return <section className="w-full px-5 md:px-8 py-24 md:py-40 bg-primary text-base text-center overflow-hidden" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-base/80 uppercase tracking-[0.2em] text-[11px] md:text-xs font-semibold mb-6" data-id="element-125">
          Presentamos…
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-serif text-5xl md:text-7xl lg:text-8xl mb-8 leading-[1.05] md:leading-[0.98] tracking-tight" data-id="element-126">
          MOVÉ SUAVE™
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl md:text-3xl font-medium mb-6 leading-[1.4]" data-id="element-127">
          El primer ecosistema premium de movimiento suave y bienestar
          emocional.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-[17px] md:text-xl text-base/80 max-w-2xl mx-auto mb-20 leading-[1.75]" data-id="element-128">
          Sentite mejor física y emocionalmente — incluso en tus días más
          difíciles. Sin exigencia.{' '}
          <em className="italic font-serif" data-id="element-129">Sin culpa.</em> Sin rutinas
          imposibles.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="relative w-full max-w-3xl mx-auto rounded-3xl overflow-hidden shadow-2xl bg-secondary/20 p-2 md:p-4" data-id="element-130">
          <div className="rounded-2xl overflow-hidden" data-id="element-131">
            <img src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=2120&auto=format&fit=crop" alt="MOVÉ SUAVE App Mockup" className="w-full h-auto object-cover" data-id="element-132" />
          </div>
        </motion.div>
      </div>
    </section>;
}